import tampuuriWindowObject from "../../tampuuriWindowObject";

export const imageCache = new Map();
export const MAX_CACHE_SIZE = () => 500;

// set cache entry
export const setImageCache = (key, src) => {
  if (imageCache.size >= MAX_CACHE_SIZE) {
    const firstKey = imageCache.keys().next().value;
    cache.delete(firstKey);
  }
  imageCache.set(key, src);
};

// get cached src by key
export const getCachedImage = (key) => {
  return imageCache.get(key);
};

// check if image for key exists
export const hasCachedImage = (key) => {
  return imageCache.has(key);
};
